// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"167":"6bfbb7da","239":"c5f68727","453":"825386d9","455":"a586c8e4","661":"7d0836d1","977":"52f93b31"}[chunkId] + ".chunk.js";
};